import React from "react";
import * as CHQ from "chq";

import { useProfile } from "app/context";
import ErrorBoundary from "components/common/ErrorBoundary";
import { TimeDiff } from "components/common/Time";

import notificationFor from "./notificationFor";

type NotificationItemProps = {
  notification: CHQ.Notification;
  tabIndex: number;
};

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, tabIndex }) => {
  const { profile } = useProfile();
  return (
    <div className="notification notification-drawer__notification">
      <div>
        <ErrorBoundary>
          {notificationFor(notification, tabIndex, undefined, profile)}
          <span className="notification-drawer__timestamp">
            <TimeDiff time={notification.createdAt} />
          </span>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default NotificationItem;
